'use strict';

angular.module('ClinicApp').factory('DoctorService', function($q, $http, DoctorResource, DoctorSpecialtyAddResource, DoctorSpecialtyRemoveResource, DoctorLanguageAddResource, DoctorLanguageRemoveResource, DoctorInsurancePlanResource, PermissionResource, ClinicConfig) {
  return {
    createDoctor: function(data) {
      return DoctorResource.save(data).$promise;
    },

    getDoctor: function(id, params) {
      params = params || {};

      return $q.when().then(function() {
        if (angular.isArray(id)) {
          params.id = id.join(',');
          return $http.get(ClinicConfig.HOSTNAME + '/doctor', {
            params: params,
          });
        } else {
          return $http.get(ClinicConfig.HOSTNAME + '/doctor/' + id, {
            params: params,
          });
        }
      })
        .then(function(response) {
          return response.data;
        });
    },

    getDoctorPermissions: function(doctorId) {
      return PermissionResource.query({
        modelType: 'doctor',
        id: doctorId,
      }).$promise;
    },

    addLanguages: function(doctorId, languageIds) {
      var promises = [];
      angular.forEach(languageIds, function(languageId) {
        promises.push(DoctorLanguageAddResource.save({
          doctor: doctorId,
          id: languageId,
        }, null).$promise);
      });
      return promises.length ? $q.all(promises) : $q.when();
    },

    // Adds the specialty and returns new list of the doctor specialties.
    addSpecialty: function(doctorId, specialtyId) {
      var _this = this;
      return DoctorSpecialtyAddResource.save({
        id: specialtyId,
        doctor: doctorId,
      }, null).$promise.then(function() {
        return _this.getDoctor(doctorId);
      }).then(function(doctor) {
        return doctor.specialties;
      });
    },

    removeDoctor: function(doctorId) {
      return DoctorResource.remove({
        id: doctorId,
      }).$promise;
    },

    removeLanguages: function(doctorId, languageIds) {
      var promises = [];
      angular.forEach(languageIds, function(languageId) {
        promises.push(DoctorLanguageRemoveResource.remove({
          doctor: doctorId,
          id: languageId,
        }, null).$promise);
      });
      return promises.length ? $q.all(promises) : $q.when();
    },

    // Removes the specialty and returns new list of the doctor specialties.
    removeSpecialty: function(doctorId, specialtyId) {
      var _this = this;
      return DoctorSpecialtyRemoveResource.remove({
        id: specialtyId,
        doctor: doctorId,
      }, null).$promise.then(function() {
        return _this.getDoctor(doctorId);
      }).then(function(doctor) {
        return doctor.specialties;
      });
    },

    updateDoctor: function(doctor, data) {
      if (typeof data !== 'object' || !Object.keys(data).length) {
        return $q.when();
      }
      return DoctorResource.update({
        id: doctor.id,
      }, {
        name: doctor.name,
        ...data,
      }).$promise;
    },

    updateInsurancePlans: function(doctorId, insurancePlanIds) {
      return DoctorInsurancePlanResource.update({
        doctorId: doctorId,
      }, {
        insurancePlanIds: insurancePlanIds || [],
      }).$promise;
    },

    getInNetwork: function(doctorId, planName, providerName) {
      return $http({
        method: 'GET',
        url: ClinicConfig.HOSTNAME + '/doctor/' + doctorId + '/insurance/network/',
        params: {
          planName: planName,
          providerName: providerName,
        },
      });
    },

    addInsurancePlan: function(doctorId, planName, providerName) {
      return DoctorInsurancePlanResource.add({
        doctorId: doctorId,
      }, {
        planName: planName,
        providerName: providerName,
      }).$promise;
    },

    removeInsurancePlan: function(doctorId, planName, providerName) {
      return $http({
        method: 'DELETE',
        url: ClinicConfig.HOSTNAME + '/doctor/' + doctorId + '/insurance/',
        data: {
          planName: planName,
          providerName: providerName,
        },
      });
    },

    synchronizeSpecialties: function(currentIds, chosenIds, doctorId) {
      var idsToAdd = _.difference(chosenIds, currentIds);
      var idsToRemove = _.difference(currentIds, chosenIds);
      var _this = this;
      _.forEach(idsToAdd, function(id) {
        return _this.addSpecialty(doctorId, id);
      });
      _.forEach(idsToRemove, function(id) {
        return _this.removeSpecialty(doctorId, id);
      });
      return _this.getDoctor(doctorId).then(function(doctor) {
        return doctor.specialties;
      });
    },

    synchronizeLanguages: function(doctorId, currentIds, chosenIds) {
      var idsToAdd = _.difference(chosenIds, currentIds);
      var idsToRemove = _.difference(currentIds, chosenIds);
      var _this = this;

      return _this.addLanguages(doctorId, idsToAdd).then(function() {
        return _this.removeLanguages(doctorId, idsToRemove);
      });
    },
  };
});
